// extracted by mini-css-extract-plugin
export var active = "_dv-2";
export var recordingDot = "_dv-1";
export var recordingIndicator = "_dv-0";